var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb",
      on: { mouseenter: _vm.enableSelection, mouseleave: _vm.pauseSelection },
    },
    [
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _c(
            "div",
            { staticClass: "thumb-image" },
            [
              _c("mh-category-item-image", {
                ref: "itemImages",
                attrs: {
                  item: _vm.item,
                  "url-with-variation-id": _vm.urlWithVariationId,
                  lazy: _vm.position === -1 || _vm.position > 4,
                },
              }),
              _vm._v(" "),
              _c(
                "lazy-hydrate",
                { attrs: { never: "" } },
                [
                  _c("mh-category-variation-tags", {
                    attrs: {
                      "variation-properties": _vm.item.variationProperties,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("mh-add-to-wish-list", {
            attrs: {
              "variation-id": _vm.item.variation.id,
              "item-id": _vm.item.item.id,
              "hide-text": "",
            },
            on: { "item-added": _vm.onItemAddToWishList },
          }),
          _vm._v(" "),
          _vm._t("item-details", [
            _c(
              "div",
              { staticClass: "thumb-content" },
              [
                _vm.showVariations
                  ? _c("mh-category-variation-selection", {
                      ref: "categoryVariationSelection",
                      attrs: {
                        item: _vm.item,
                        variationId: _vm.item.variation.id,
                        variationProperties: _vm.item.variationProperties,
                      },
                      on: {
                        "image:overwrite": function (ev) {
                          return _vm.$refs.itemImages.overwriteImage(ev)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "pt-2 thumb-title",
                    attrs: {
                      href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId),
                    },
                  },
                  [
                    _c("span", { staticClass: "thumb-title-manufacturer" }, [
                      _vm._v(_vm._s(_vm.item.item.manufacturer.externalName)),
                    ]),
                    _c("br"),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm._f("truncate")(_vm.productTitle, 95)) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._t("before-prices"),
                _vm._v(" "),
                _c(
                  "lazy-hydrate",
                  { attrs: { never: "" } },
                  [
                    _c("mh-category-variation-price", {
                      attrs: {
                        item: _vm.item,
                        minimumAbsoluteValue:
                          _vm.crossPriceMinimumAbsoluteValue,
                        minimumPercentageValue: _vm.crossPriceMinimumPercentage,
                        youSaveText: _vm.$translate(
                          "modeherz::CategoryPageClient.categoryPageItemYouSave"
                        ),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._t("after-prices"),
                _vm._v(" "),
                !(
                  _vm.item.unit.unitOfMeasurement === "C62" &&
                  _vm.item.unit.content === 1
                )
                  ? _c("div", { staticClass: "category-unit-price small" }, [
                      _c("span", [_vm._v(_vm._s(_vm.item.unit.content))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.item.unit.names.name)),
                      ]),
                      _vm._v(" "),
                      _vm.item.variation.mayShowUnitPrice
                        ? _c("span", [
                            _vm._v(
                              " | " + _vm._s(_vm.item.prices.default.basePrice)
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }